import { Divider, Popup } from '@approvalmax/ui/src/components';
import range from 'lodash/range';
import { memo } from 'react';
import Skeleton from 'react-loading-skeleton';

import { BankAccountCard } from './components/BankAccountCard/BankAccountCard';
import { skeletonBankAccountCount } from './SelectBankAccountPopupContent.constants';
import { messages } from './SelectBankAccountPopupContent.messages';

export const Loading = memo(() => {
    return (
        <>
            <Popup.Header title={messages.title} actions={<Skeleton width={60} height={40} />} />

            <Popup.Body spacing='32'>
                {range(skeletonBankAccountCount).map((index) => (
                    <div key={index}>
                        <BankAccountCard.Loading />

                        {index < skeletonBankAccountCount - 1 && <Divider color='midnight50' />}
                    </div>
                ))}
            </Popup.Body>
        </>
    );
});

Loading.displayName = 'Loading';
